var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"main-title"},[_vm._v("第三方平台")]),_vm._v(" "),_c('div',{staticClass:"main-top"},[_c('third')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }